// client/src/components/StatsCards.jsx
import React from "react";

const Card = ({ icon, label, value, sub, color, alert, onClick, active }) => (
  <div
    onClick={onClick}
    style={{
      background: alert ? "linear-gradient(135deg, #fff5f5, #fff)" : active ? `linear-gradient(135deg, ${color}12, ${color}08)` : "white",
      borderRadius: 16,
      padding: "22px 26px",
      border: active ? `2px solid ${color}` : alert ? "1.5px solid #fca5a5" : "1px solid #e8ecf0",
      display: "flex",
      flexDirection: "column",
      gap: 10,
      position: "relative",
      overflow: "hidden",
      cursor: onClick ? "pointer" : "default",
      transition: "all 0.2s ease",
      transform: active ? "scale(1.02)" : "none",
      boxShadow: active ? `0 4px 12px ${color}30` : "none",
    }}
  >
    <div style={{
      position: "absolute", top: 0, right: 0,
      width: 80, height: 80, borderRadius: "0 16px 0 80px",
      background: `${color}18`,
    }} />
    <div style={{
      width: 40, height: 40, borderRadius: 12,
      background: `${color}22`, display: "flex",
      alignItems: "center", justifyContent: "center",
      fontSize: 18,
    }}>
      {icon}
    </div>
    <div>
      <p style={{ margin: "0 0 2px", fontSize: 12, fontWeight: 600, color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.06em" }}>
        {label}
      </p>
      <p style={{ margin: 0, fontSize: 28, fontWeight: 800, color: alert ? "#ef4444" : "#0f172a", lineHeight: 1.1 }}>
        {value}
      </p>
      {sub && <p style={{ margin: "4px 0 0", fontSize: 12, color: alert ? "#ef4444" : "#64748b" }}>{sub}</p>}
    </div>
    {onClick && (
      <div style={{
        position: "absolute", bottom: 8, right: 12,
        fontSize: 10, color: active ? color : "#cbd5e1",
        fontWeight: 600,
      }}>
        {active ? "✕ clear" : "click to filter"}
      </div>
    )}
  </div>
);

const StatsCards = ({ stats, auditSummary, activeFilter, onFilterByCard }) => {
  if (!stats) return null;

  const validated = stats.validated || 0;
  const mismatchCount = stats.location_mismatch || 0;
  const hasMismatches = mismatchCount > 0;
  const shouldCancel = stats.should_cancel || 0;
  const locationOk = stats.location_ok || 0;
  const locationDisabled = stats.location_disabled || 0;
  const hasDisabled = locationDisabled > 0;
  const validationPct = stats.total > 0 ? Math.round((validated / stats.total) * 100) : 0;

  const handleClick = (filterKey) => {
    if (!onFilterByCard) return;
    // Toggle: if already active, clear the filter
    onFilterByCard(activeFilter === filterKey ? "" : filterKey);
  };

  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(6,1fr)", gap: 16, marginBottom: 28 }}>
      <Card
        icon="📦" label="Total Orders" value={stats.total}
        sub="From ShipHero" color="#6366f1"
        onClick={() => handleClick("")}
        active={activeFilter === ""}
      />
      <Card
        icon="✅" label="Validated" value={validated}
        sub={`${validationPct}% of total`} color="#22c55e"
        onClick={() => handleClick("validated")}
        active={activeFilter === "validated"}
      />
      <Card
        icon="📍" label="Location OK" value={locationOk}
        sub={validated > 0 ? `${Math.round((locationOk / validated) * 100)}% of validated` : "—"}
        color="#10b981"
        onClick={() => handleClick("location_ok")}
        active={activeFilter === "location_ok"}
      />
      <Card
        icon="🔄" label="Should Cancel" value={shouldCancel}
        sub={`${stats.pending_cancel || 0} pending`} color="#f59e0b"
        onClick={() => handleClick("should_cancel")}
        active={activeFilter === "should_cancel"}
      />
      <Card
        icon={hasMismatches ? "🚨" : "🛡️"}
        label="Mismatches"
        value={mismatchCount}
        sub={hasMismatches ? `${stats.executed || 0} executed` : "All clear"}
        color={hasMismatches ? "#ef4444" : "#10b981"}
        alert={hasMismatches}
        onClick={() => handleClick("mismatch")}
        active={activeFilter === "mismatch"}
      />
      <Card
        icon={hasDisabled ? "⛔" : "✓"}
        label="Loc. Disabled"
        value={locationDisabled}
        sub={hasDisabled ? "From SH history" : "None detected"}
        color={hasDisabled ? "#dc2626" : "#94a3b8"}
        alert={hasDisabled}
        onClick={() => handleClick("location_disabled")}
        active={activeFilter === "location_disabled"}
      />
    </div>
  );
};

export default StatsCards;
